import Vue from 'vue'

import Table from './table'
import Router from './router'
import Accordion from './accordion'
import HelperFile from './helperFile'
import Swal from './swalHelperComponent'
import FilterHelper from './filterHelper'
import RequestServiceHelper from './requestServiceHelper'
import ComponentServiceHelper from './componentServiceHelper'
import ComponentSaleServiceHelper from './componentSaleServiceHelper'
import ComponentGlobalActionsFilter from './componentGlobalActionsFilter'
import ComponentTicketServiceHelper from './componentTicketServiceHelper'
import ComponentNotificationServiceHelper from './componentNotificationServiceHelper'

const Component = Vue.extend({
  name: 'helper-componenter',
  mixins: [
    Swal,
    Table,
    Router,
    Accordion,
    HelperFile,
    FilterHelper,
    RequestServiceHelper,
    ComponentServiceHelper,
    ComponentSaleServiceHelper,
    ComponentGlobalActionsFilter,
    ComponentTicketServiceHelper,
    ComponentNotificationServiceHelper,
  ],
  data() {
    return {
      finderDefault: {
        module: 'App\\Models\\PreContratoCliente',
        order_column: 'created_at',
        order_direction: 'desc',
        filter_match: 'or',
        limit: 10,
        finderParameters: [
          { name: 'id', operator: 'equal_to' },
          { name: 'personas.cedula', operator: 'contains' },
          { name: 'personas.email', operator: 'contains' },
          { name: 'personas.celular', operator: 'contains' },
        ],
      },
    }
  },
  methods: {
    /**
     * @param VueComponent reference
     * @param Promise promise
     */
    checkBeforeReferenceLoading(reference, promise) {
      console.log(reference, promise)
    },
  },
})

export default Component
